{
  "PAGINATION_FOOTER": {
    "SHOWING": "Zobrazuje sa {startItem} - {endItem} z {totalItems} položiek",
    "CURRENT_PAGE_INFO": "Strana {currentPage} z {totalPages}"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Vyberte možnosť...",
    "EMPTY_SEARCH_RESULTS": "Pre hľadaný výraz `{searchTerm}` neboli nájdené žiadne položky",
    "EMPTY_STATE": "Žiadne výsledky neboli nájdené.",
    "SEARCH_PLACEHOLDER": "Hľadať...",
    "MORE": "+{count} ďalších"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Hľadať...",
    "EMPTY_STATE": "Žiadne výsledky neboli nájdené.",
    "SEARCHING": "Hľadá sa..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Zrušiť",
      "CONFIRM": "Potvrdiť"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Hľadať krajinu",
    "ERROR": "Telefónne číslo musí byť prázdne alebo vo formáte E.164",
    "DIAL_CODE_ERROR": "Vyberte prosím predvoľbu zo zoznamu"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Autor nie je k dispozícii"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Navigačná cesta"
  },
  "SWITCH": {
    "TOGGLE": "Prepínač"
  },
  "LABEL": {
    "TAG_BUTTON": "štítok"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Zistiť viac",
    "WATCH_VIDEO": "Prehrať video"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Zobraziť farby",
    "HIDE_COLORS": "Skryť farby"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minúty",
    "HOURS": "Hodiny",
    "DAYS": "Dni",
    "PLACEHOLDER": "Zadajte dobu"
  }
}
